/* eslint-disable eqeqeq */
import { createActions, Store } from 'reflux'
import Proxies from 'Components/proxies'
import { toast } from 'react-toastify'
const { GET, POST } = Proxies
import _ from 'lodash'
import { download } from 'Components/download'
import Papa from 'papaparse'
import Reflux from 'reflux'
import { PurchaseOrderStoreActions } from './purchaseOrderStore'
export const OrderActions = createActions([
  'getOrders',
  'getOrder',
  'getMsbAdminUsers',
  'selectOrder',
  'selectOrderLine',
  'refundOrder',
  /* FILTER RELATERET */
  'getSuppliers',
  'getManufacturers',
  'addFilter',
  'updateFilter',
  'removeFilter',
  'fastFilter',
  'applyFilters',
  'shipOrder',
  'printOrder',
  'updateOrder',
  { saveOrder: { children: ['completed'] } },
  'clearFilters',
  'removeFilter',
  'removePreDefinedFilter',
  'addFilterText',
  'updateOrderInstant',
  'expandOrderlines',
  'collapseOrderlines',
  'removeDynamicFilters',
  'removePredefinedFilters',
  'updateOrderGlobal',
  { createCustomOrder: { children: ['completed', 'failed'] } },
  { getUserBalance: { children: ['completed', 'failed'] } },
  { getUserDeliveryInformation: { children: ['completed', 'failed'] } },
  'copyToClipboard',
  'clearToast',
  'copyOrderLineTitle',
  'setTooltip',
  'setFilterText',
  'setSortData',
  'clearPrintToast',
  'setOrderFilter',
  'setAllChecked',
  'selectOrderHandler',
  'bulkUpdateSeasonOrderStatus',
  'getSelectedOrders',
  'logoutModal',
  'selectAllOrderLines',
  'generateRegularShipment',
  'generateDropShipment',
  'handleScrollPosition',
  'handleClick',
  'setPaginationPoint',
  'setPaginationAmount',
  'addTracking',
  'setTracking',
  'saveTrackingDetails',
  'removeTracking',
  'clearC5Error',
  'setRefundFreight',
  'setAddRefundToStock',
  'setShowRefundModal',
  'setShowNotifyModal',
  'getUserNotificationType',
  'totalOrders',
  'assignOrder',
  'reserveStock',
  'releaseStock',
  'generatePurchaseOrder',
  'getTrackingDetails',
  'getTrackAndTraceEvents',
  'getCarriers',
  'setTrackingNumber',
  'setOrderCarrier',
  'goToTrackingUrl',
  'setOverrideShipmentDate',
  'setExpectedShipmentDate',
  'saveShipmentDates'
])

export class OrderStore extends Store {
  constructor(props) {
    super(props)
    this.listenables = OrderActions
    this.state = {
      orders: [],
      fetchingOrders: false,
      fetchingSingleOrder: false,
      orderDetails: [],
      msbAdminUsers: [],
      manufacturers: [],
      suppliers: [],
      userBalance: null,
      filters: [],
      seasonOrderFilters: [],
      selectedOrders: [],
      selectedOrderLines: [],
      predefinedFilters: [
        { name: 'Mine ordrer', column: 'assignedUserID', value: Reflux.GlobalState.LoginStore.user.UserID, selected: false },
        { name: 'Ny', column: 'orderFlowStatus', value: 'NEW', selected: true },
        { name: 'Afventer', column: 'orderFlowStatus', value: 'TENTATIVE', selected: false },
        { name: 'Backorder', column: 'orderFlowStatus', value: 'BACKORDER', selected: false },
        { name: 'Bestilt', column: 'orderFlowStatus', value: 'ORDERED', selected: false },
        { name: 'Pakket', column: 'orderFlowStatus', value: 'PACKED', selected: false },
        { name: 'Sendt', column: 'orderFlowStatus', value: 'SHIPPED', selected: false },
        { name: 'Modtaget', column: 'orderFlowStatus', value: 'RECEIVED', selected: false },
        { name: 'Refunderet', column: 'orderFlowStatus', value: 'REFUNDED', selected: false },
        { name: 'Reklamation', column: 'orderFlowStatus', value: 'COMPLAINT', selected: false },
        { name: 'Afvist', column: 'orderFlowStatus', value: 'DECLINED', selected: false },
        { name: 'Fejlet', column: 'orderFlowStatus', value: 'FAILED', selected: false },
        { name: 'Preorder', column: 'orderFlowStatus', value: 'PREORDER', selected: false }
      ],
      seasonOrderPredefinedFilters: [
        { name: 'Ny', column: 'orderFlowStatus', value: 'NEW', selected: true },
        { name: 'Afventer', column: 'orderFlowStatus', value: 'TENTATIVE', selected: false },
        { name: 'Skal bestilles', column: 'orderFlowStatus', value: 'TO_ORDER', selected: false },
        { name: 'Bestilt', column: 'orderFlowStatus', value: 'ORDERED', selected: false },
        { name: 'Modtaget', column: 'orderFlowStatus', value: 'RECEIVED', selected: false },
        { name: 'Pakket', column: 'orderFlowStatus', value: 'PACKED', selected: false },
        { name: 'Sendt', column: 'orderFlowStatus', value: 'SHIPPED', selected: false }
      ],
      orderStatus: '',
      paginationPoint: 0,
      paginationAmount: 25,
      showTooltip: false,
      filterText: '',
      showClipBoardMessage: false,
      fetchingPrintOrderTemplate: true,
      printOrderTemplate: null,
      fetchingPrintOrderTemplateFailed: false,
      showPrintDialog: false,
      printErrorMessage: null,
      isCustomOrder: null,
      orderFilter: 'order',
      filterName: 'filters',
      isAllChecked: false,
      isAllOrderLinesChecked: false,
      isIndeterminate: false,
      c5SelectedOrders: [],
      previewOrders: false,
      scrollPosition: null,
      refundedOrder: {},
      c5SupplierError: null,
      showRefundModal: false,
      refundFreight: false,
      addRefundToStock: false,
      OrderID: null,
      sortData: {
        column: 'timeInsert',
        dir: 'DESC'
      },
      totalOrders: 0,
      showNotifyModal: false,
      notifyUserID: 0,
      trackingDetails: {
        TrackingOrderID: 0,
        CarrierID: 0,
        trackingNumber: ''
      },
      trackAndTraceEvents: [],
      carriers: []
    }
  }
  setRefundFreight(e) {
    this.setState({ refundFreight: e.target.checked })
  }
  setAddRefundToStock(e) {
    this.setState({ addRefundToStock: e.target.checked })
  }
  setShowRefundModal(showModal, OrderID) {
    this.setState({ showRefundModal: showModal, OrderID })
  }
  setShowNotifyModal(showModal, OrderID, UserID) {
    this.setState({ showNotifyModal: showModal, OrderID, notifyUserID: UserID })
  }
  setNotificationType(value) {
    this.setState({ notificationType: value })
  }
  setOrderFilter(orderFilter) {
    this.setState({ orderFilter, filterName: orderFilter === 'order' ? 'filters' : 'seasonOrderFilters', paginationPoint: 0, sortColumn: '' })
  }
  handleClick() {
    this.setState({ scrollPosition: window.pageYOffset })
  }
  setPaginationPoint(paginationPoint) {
    this.setState({ paginationPoint })
  }
  setPaginationAmount(paginationAmount) {
    this.setState({ paginationAmount })
  }
  getOrders(isPopUp = false, appliedFilter = []) {
    const limit = this.state.paginationAmount
    const offset = this.state.paginationAmount * this.state.paginationPoint
    const sortColumn = this.state.sortData.column
    const sortDir = this.state.sortData.dir
    this.setState({ fetchingOrders: true })
    let nextState = {
      fetchingOrders: false,
      orders: [],
      [this.state.filterName]: this.state[this.state.filterName],
      selectedOrderLines: this.state.selectedOrderLines,
      predefinedFilters: this.state.predefinedFilters,
      seasonOrderPredefinedFilters: this.state.seasonOrderPredefinedFilters,
      totalOrders: 0
    }
    let filters
    if (appliedFilter.length > 0) {
      filters = appliedFilter
        .filter(e => {
          return e.column != '' && e.value != '' && e.column !== 'orderFlowStatus'
        })
        .map(e => {
          return { column: e.column, operator: e.operator ? e.operator : 'LIKE', value: e.value }
        })
    } else {
      filters = this.state[this.state.filterName]
        .filter(e => {
          return e.column != '' && e.value != '' && e.column !== 'orderFlowStatus'
        })
        .map(e => {
          return { column: e.column, operator: e.operator ? e.operator : 'LIKE', value: e.value }
        })
    }

    let statusFilter = this.state[this.state.filterName].filter(e => e.column === 'orderFlowStatus')
    if (!isPopUp) {
      if (statusFilter.length) {
        statusFilter = statusFilter.map(e => e.value)
      }
      if (statusFilter.length) {
        filters.push({ column: 'orderFlowStatus', operator: 'LIKE', value: statusFilter })
      }
    }

    if (!filters.length && !isPopUp) {
      filters.push({ column: 'orderFlowStatus', operator: 'LIKE', value: ['NEW'] })
      nextState[this.state.filterName].push({ filterID: 0, column: 'orderFlowStatus', operator: 'LIKE', value: 'NEW' })
    }
    if (this.state.orderFilter === 'seasonOrder') {
      nextState.seasonOrderPredefinedFilters = this.refreshPredefinedFilters('seasonOrderPredefinedFilters')
    } else {
      nextState.predefinedFilters = this.refreshPredefinedFilters('predefinedFilters')
    }

    filters.push(
      this.state.orderFilter === 'seasonOrder'
        ? { column: 'orderType', operator: 'LIKE', value: 'SEASON' }
        : { column: 'orderType', operator: 'LIKE', value: 'TRANSACTION' }
    )

    GET('orders/admin-pool-paged', {
      filter: filters,
      sortColumn: sortColumn,
      sortDir: sortDir,
      searchTerm: this.state.filterText,
      offset: offset,
      limit: limit
    }).then(responseJSON => {
      if (responseJSON && !responseJSON.error) {
        responseJSON.pagedItems.forEach(element => {
          element.checked = false
        })
        nextState.orders = responseJSON.pagedItems
        nextState.selectedOrderLines = []
        nextState.isAllChecked = false
        nextState.isAllOrderLinesChecked = false
        nextState.totalOrders = responseJSON.allItemsCount

        if (responseJSON.allItemsCount > 0 && responseJSON.allItemsCount < this.state.paginationAmount * this.state.paginationPoint) {
          this.setState({ paginationPoint: 0 })
          this.getOrders()
        }
      } else {
        nextState.paginationPoint = 0
      }
      this.setState(nextState)
    })
  }
  getOrder(OrderID = null) {
    if (OrderID == null) {
      return false
    }
    this.setState({ fetchingSingleOrder: true })
    let nextState = {
      fetchingSingleOrder: false,
      orderDetails: [],
      trackAndTraceEvents: []
    }
    GET('orders/fetch', { OrderID: OrderID }).then(responseJSON => {
      if (responseJSON) {
        nextState.orderDetails = responseJSON
        this.setState({ isCustomOrder: responseJSON.orderCustomOrder })
      }
      this.setState(nextState)
    })
  }
  getMsbAdminUsers() {
    GET('user/msb-admin-users').then(responseJSON => {
      if (responseJSON) {
        this.setState({ msbAdminUsers: responseJSON })
      }
    })
  }
  selectOrder(OrderID) {
    let selectedOrders = this.state.selectedOrders
    let index = selectedOrders.findIndex(e => {
      return e == OrderID
    })
    if (index != -1) {
      selectedOrders.splice(index, 1)
    } else {
      selectedOrders.push(OrderID)
    }
    this.setState({ selectedOrders: selectedOrders })
  }
  selectOrderLine(OrderLineID, orderlines = []) {
    let selectedOrderLines = this.state.selectedOrderLines
    let isAllOrderLinesChecked = this.state.isAllOrderLinesChecked
    let isIndeterminate = this.state.isIndeterminate
    let OrderlineIDs = [OrderLineID]
    if (orderlines.length) {
      OrderlineIDs = orderlines.map(ol => ol.OrderlineID)
    }
    for (OrderLineID of OrderlineIDs) {
      let index = selectedOrderLines.findIndex(e => {
        return e == OrderLineID
      })
      if (index != -1) {
        selectedOrderLines.splice(index, 1)
        if (isAllOrderLinesChecked) {
          isAllOrderLinesChecked = false
          isIndeterminate = true
        }
      } else {
        selectedOrderLines.push(OrderLineID)
      }
      this.setState({ selectedOrderLines: selectedOrderLines, isAllOrderLinesChecked: isAllOrderLinesChecked, isIndeterminate: isIndeterminate })
    }
  }
  refundOrder(OrderID, refundFreight = false, addRefundToStock = false) {
    let order = {}
    order[OrderID] = true
    this.setState({ refundedOrder: order })
    POST('orders/refund', { OrderID, refundFreight: refundFreight ? 1 : 0, addToStock: addRefundToStock ? 1 : 0 })
      .then(response => {
        this.setState({ refundedOrder: {}, refundFreight: false, addRefundToStock: false, OrderID: null })
        if (response.error) {
          this.setState({ orderStatus: false })
        } else {
          this.setState({ orderStatus: true })
          this.getOrders()
        }
      })
      .catch(() => this.setState({ refundedOrder: {} }))
  }
  getUserNotificationType(UserID) {
    GET('user/getUserNotificationType', { UserID: UserID })
      .then(response => {
        if (response.error) {
          this.setState({ userNotificationType: undefined })
        } else {
          this.setState({ userNotificationType: response })
        }
      })
      .catch(() => this.setState({ userNotificationType: undefined }))
  }
  getManufacturers() {
    GET('categories/pool', { categoryTaxonomy: 'MANUFACTURER' }).then(responseJSON => {
      if (responseJSON) {
        this.setState({ manufacturers: responseJSON })
      }
    })
  }

  getSuppliers() {
    GET('suppliers/pool').then(responseJSON => {
      if (responseJSON) {
        this.setState({ suppliers: responseJSON })
      }
    })
  }
  shipOrder(OrderID, isNavigate = false, props) {
    POST('orders/ship', { OrderID: OrderID }).then(responseJSON => {
      if (responseJSON.error) {
        toast.error(responseJSON.error.message || 'Could not ship order', {
          autoClose: 7500,
          onClose: () => {
            OrderActions.clearToast()
          }
        })
      } else {
        isNavigate && props.history.push('/orders')
        this.setState({ orderStatus: true })
        this.getOrders()
      }
    })
  }
  printOrder(OrderID) {
    if (OrderID) {
      this.setState({ fetchingPrintOrderTemplate: true, printErrorMessage: null })
      POST('orders/print', { OrderID: OrderID }).then(responseJSON => {
        if (responseJSON.error) {
          this.setState({ fetchingPrintOrderTemplateFailed: true, printErrorMessage: responseJSON.error })
        } else {
          this.setState({ fetchingPrintOrderTemplate: false, showPrintDialog: true, printOrderTemplate: responseJSON })
        }
      })
    }
  }
  saveOrder(orderDetailsForm) {
    return POST('orders/update', {
      OrderIDs: [this.state.orderDetails.OrderID],
      orderFlowStatus: orderDetailsForm.orderFlowStatus,
      orderWeight: orderDetailsForm.orderWeight,
      orderParcels: orderDetailsForm.orderParcels,
      orderDropShipment: orderDetailsForm.orderDropShipment,
      orderComment: orderDetailsForm.orderComment,
      orderConsignee: orderDetailsForm.orderConsignee,
      orderConsigneeName: orderDetailsForm.orderConsigneeName,
      orderConsigneeAddress1: orderDetailsForm.orderConsigneeAddress1,
      orderConsigneeAddress2: orderDetailsForm.orderConsigneeAddress2,
      orderConsigneeZipcode: orderDetailsForm.orderConsigneeZipcode,
      orderConsigneeCity: orderDetailsForm.orderConsigneeCity,
      orderConsigneeCountry: orderDetailsForm.orderConsigneeCountry,
      orderConsigneeEmail: orderDetailsForm.orderConsigneeEmail,
      orderConsigneePhone: orderDetailsForm.orderConsigneePhone,
      orderRemarks: orderDetailsForm.orderRemarks,
      ParcelshopID: orderDetailsForm.ParcelshopID ? parseInt(orderDetailsForm.ParcelshopID) : undefined,
      orderGlsCustomerNumber: orderDetailsForm.orderGlsCustomerNumber,
      userOrderRemarks: orderDetailsForm.userOrderRemarks,
      AddressID: Number(orderDetailsForm.AddressID),
      supportTicketLink: orderDetailsForm.supportTicketLink
    }).then(responseJSON => {
      if (responseJSON && !responseJSON.error) {
        this.setState({ orderDetails: responseJSON })
      }
      OrderActions.saveOrder.completed()
    })
  }
  assignOrder(assignedUserID) {
    return POST('orders/assign', {
      orderID: this.state.orderDetails.OrderID,
      assignedUserID: Number(assignedUserID)
    }).then(responseJSON => {
      if (responseJSON && !responseJSON.error) {
        toast.success('Ansvarlig blev ændret', {
          autoClose: 5000,
          onClose: () => {
            OrderActions.clearToast()
          }
        })
        this.setState({ orderDetails: { ...this.state.orderDetails, assignedUserID: assignedUserID } })
      } else {
        toast.error('Ansvalig kunne ikke ændres', {
          autoClose: 5000,
          onClose: () => {
            OrderActions.clearToast()
          }
        })
      }
    })
  }
  updateOrder(field) {
    const name = field.target.name
    let value = field.target.value
    let orderDetails = this.state.orderDetails
    orderDetails[name] = value
    this.setState({ orderDetails })
  }
  updateOrderInstant(field, order) {
    let value = field.target.value
    let allOrders = this.state.orders
    let refreshOrder = allOrders.filter(o => o.OrderID === order.OrderID)[0]
    refreshOrder.orderFlowStatus = value
    POST('orders/update', { OrderIDs: [order.OrderID], orderFlowStatus: value }).then(responseJSON => {
      if (!responseJSON.error) {
        this.setState({ orderStatus: true })
        this.getOrders()
      } else {
        this.setState({ orderStatus: false })
      }
    })
  }
  addFilter(data = {}, update = false) {
    let filters = this.state[this.state.filterName]
    let lastFilterID = -1
    if (filters.length > 0) {
      let filterIDs = filters.map(e => {
        return e.filterID
      })
      lastFilterID = filterIDs.reduce((a, b) => {
        return Math.max(a, b)
      })
    }
    let filter = { filterID: lastFilterID + 1 }
    if (!data.column) {
      data = { column: '', operator: '', value: '' }
    }
    Object.assign(filter, data)
    filters.push(filter)
    this.setState({ [this.state.filterName]: filters })
    if (update) {
      this.applyFilters()
    }
  }
  removeFilter(column, update = false) {
    let filters = this.state[this.state.filterName]
    filters = filters.filter(e => {
      return e.column != column
    })
    this.setState({ [this.state.filterName]: filters })
    if (update || filters.length === 0) {
      this.applyFilters()
    }
  }
  updateFilter(editFilter, field) {
    let filterID = editFilter.filterID
    let fieldName = field.target.name
    let fieldValue = field.target.value
    let filters = this.state[this.state.filterName]
    for (let filter of filters) {
      if (filter.filterID == filterID) {
        filter[fieldName] = fieldValue
        if (fieldName == 'column') {
          filter.value = ''
        }
      }
    }
    this.setState({ [this.state.filterName]: filters })
  }
  fastFilter(filterData) {
    let nextState = { filters: this.state[this.state.filterName], predefinedFilters: this.state.predefinedFilters }
    nextState[this.state.filterName] = [filterData]
    this.setState(nextState)
    this.applyFilters()
  }
  applyFilters() {
    // if (filters) {
    //   this.setState({ filters: filters })
    // }
    this.getOrders()
  }
  clearFilters() {
    this.setState({ filters: [], seasonOrderFilters: [] })
  }
  removePreDefinedFilter(filterData) {
    let filters = this.state[this.state.filterName]
    filters = filters.filter(fil => !(fil.column == filterData.column && fil.value === filterData.value))
    this.setState({ [this.state.filterName]: filters })
    this.applyFilters()
  }
  refreshPredefinedFilters(filter) {
    let predefinedFilters = this.state[filter]
    predefinedFilters = predefinedFilters.map(fil => {
      fil.selected = false
      return fil
    })
    for (let fil of predefinedFilters) {
      for (let f of this.state[this.state.filterName]) {
        if (fil.column === f.column && fil.value === f.value) {
          fil.selected = true
        }
      }
    }
    return predefinedFilters
  }
  expandOrderlines(ol) {
    let orders = this.state.orders
    let order = orders.filter(ord => ord.OrderID === ol.OrderID)
    if (order.length && order[0].orderlines) {
      let orderline = order[0].orderlines.filter(line => line.orderlineTitle === ol.orderlineTitle)
      if (orderline.length) {
        orderline[0].grouped = false
        this.setState({ orders: orders })
      }
    }
  }
  collapseOrderlines(ol) {
    let orders = this.state.orders
    let order = orders.filter(ord => ord.OrderID === ol.OrderID)
    if (order.length) {
      for (let line of order[0].orderlines) {
        if (line.orderlineTitle === ol.orderlineTitle) {
          line.grouped = true
        }
      }
      this.setState({ orders: orders })
    }
  }
  updateOrderGlobal(value, orderStatus) {
    if (orderStatus[value] && value && this.state.selectedOrderLines.length) {
      POST('orders/splice', { orderlines: this.state.selectedOrderLines, orderFlowStatus: value }).then(responseJSON => {
        if (responseJSON && !responseJSON.error) {
          this.getOrders()
          toast.success('Orderline status changed successfully.', {
            autoClose: 3000,
            onClose: () => {
              OrderActions.clearToast()
            }
          })
        }
      })
    }
  }
  bulkUpdateSeasonOrderStatus(item, bulkSelectedOrders = []) {
    let status = item.target.value
    item.target.value = false // reset the dropdown
    if (bulkSelectedOrders.length > 0) {
      POST('orders/change-status', { status, ordersArray: bulkSelectedOrders }).then(response => {
        if (response && !response.error) {
          this.getOrders()
          toast.success('Order status changed successfully.', {
            autoClose: 3000,
            onClose: () => {
              OrderActions.clearToast()
            }
          })
        }
        if (response && response.error) {
          toast.error('Error when changing status', {
            autoClose: 3000,
            onClose: () => {
              OrderActions.clearToast()
            }
          })
        }
      })
    } else {
      toast.error('No orders were selected', {
        autoClose: 7000,
        onClose: () => {
          OrderActions.clearToast()
        }
      })
    }
  }
  createCustomOrder(order) {
    if (order.brandIdentifier && order.userIdentifier) {
      POST('orders/custom-order', order).then(responseJSON => {
        if (responseJSON && !responseJSON.error) {
          let orders = this.state.orders
          orders.unshift(responseJSON)
          this.setState({ orders })
          OrderActions.createCustomOrder.completed()
        } else {
          OrderActions.createCustomOrder.failed(responseJSON.error)
        }
      })
    }
  }

  getUserBalance(brandIdentifier, userIdentifier, userCustomerNumber) {
    if (brandIdentifier && userIdentifier) {
      POST('orders/get-user-balance', { brandIdentifier: brandIdentifier.toString(), userIdentifier, userCustomerNumber }).then(responseJSON => {
        if (responseJSON && !responseJSON.error) {
          let userBalance = this.state.userBalance
          userBalance = responseJSON
          this.setState({ userBalance })
          OrderActions.getUserBalance.completed(userBalance)
        } else {
          OrderActions.getUserBalance.failed(responseJSON.error)
        }
      })
    }
  }
  getUserDeliveryInformation(brandIdentifier, userIdentifier) {
    if (brandIdentifier && userIdentifier) {
      GET('user/getUserDeliveryInformation', { brandIdentifier: brandIdentifier.toString(), userIdentifier }).then(responseJSON => {
        if (responseJSON && !responseJSON.error) {
          OrderActions.getUserDeliveryInformation.completed(responseJSON)
        } else {
          OrderActions.getUserDeliveryInformation.failed(responseJSON.error)
        }
      })
    }
  }
  copyToClipboard() {
    var range = document.createRange()
    range.selectNode(document.getElementById('deliveryInfo'))
    window.getSelection().removeAllRanges() // clear current selection
    window.getSelection().addRange(range) // to select text
    document.execCommand('copy')
    window.getSelection().removeAllRanges() // to deselect
  }

  copyOrderLineTitle(total, value) {
    this.setState({ showTooltip: false })
    if (total !== value) {
      var range = document.createElement('textarea')
      document.body.appendChild(range)
      range.value = value
      range.select()
      document.execCommand('copy')
      document.body.removeChild(range)
      this.setState({ showTooltip: true })
    }
  }

  clearToast() {
    this.setState({ orderStatus: null, showClipBoardMessage: null, fetchingPrintOrderTemplateFailed: false })
  }

  setTooltip() {
    this.setState({ showTooltip: false })
  }

  setFilterText(filterText) {
    this.setState({ filterText })
  }
  setSortData(column, dir) {
    this.setState({ sortData: { column, dir } })
  }

  clearPrintToast() {
    this.setState({ showPrintDialog: false })
  }
  setAllChecked(isAllChecked) {
    this.setState({ isAllChecked: isAllChecked })
  }
  selectOrderHandler(event, OrderID) {
    let orders = this.state.orders
    let isAllChecked = this.state.isAllChecked
    orders.forEach(element => {
      if (element.OrderID === OrderID) {
        element.checked = event.target.checked
      }
    })
    if (event.target.checked === false && isAllChecked) {
      isAllChecked = false
    }
    this.setState({ orders, isAllChecked })
  }

  getSelectedOrders() {
    let poSelectedOrders = []
    let supplier = null
    let multipleSuppliers = false
    this.state.orders.map(order => {
      if (order && order.orderlines.length > 0) {
        order.orderlines.map(item => {
          if (this.state.selectedOrderLines.includes(item.OrderlineID)) {
            if (item.product && item.product.supplier) {
              if (!!supplier && supplier !== item.product.supplier.supplierUID) {
                multipleSuppliers = true
              }
              supplier = item.product.supplier.supplierUID
            }
            if (supplier) {
              poSelectedOrders.push({
                OrderID: order.OrderID,
                OrderlineID: item.OrderlineID,
                UserID: order.UserID,
                ProductID: item.ProductID,
                VariationID: item.VariationID,
                variationUID: item.variationUID,
                address: `${order.orderConsignee}, ${order.orderConsigneeName}, ${order.orderConsigneeAddress1}, ${order.orderConsigneeZipcode} ${order.orderConsigneeCity}`,
                email: order.orderConsigneeEmail,
                phone: order.orderConsigneePhone,
                count: 1,
                vendor: supplier,
                onPurchaseOrder: item.purchaseOrderIDs.length > 0 ? 'YES' : 'NO',
                purchaseOrderIDs: item.purchaseOrderIDs,
                productPrice: item.productPrice,
                productTitle: item.orderlineTitle,
                isDropship: item.product?.supplier?.isDropship,
                unattendedDeliveryNote: item.product?.supplier?.enableDeliveryInstructions ? order.unattendedDeliveryNote : ''
              })
            }
          }
        })
      }

      return order
    })
    if (!supplier || multipleSuppliers) {
      this.setState({
        c5SupplierError: !supplier ? 'No Supplier for selected orderlines.' : 'Multiple suppliers selected. Select orderlines from only one supplier.'
      })
    } else {
      this.setState({ c5SelectedOrders: poSelectedOrders, previewOrders: true })
    }
  }
  clearC5Error() {
    this.setState({ c5SupplierError: null })
  }
  logoutModal() {
    this.setState({ previewOrders: false })
  }
  selectAllOrderLines(e) {
    let selectedOrderLines = []
    if (e.target.checked) {
      this.state.orders.map(order => {
        if (order && order.orderlines.length > 0) {
          order.orderlines.map(item => selectedOrderLines.push(item.OrderlineID))
        }
      })
    }
    this.setState({ selectedOrderLines, isAllOrderLinesChecked: e.target.checked, isIndeterminate: false })
  }
  saveC5Orderlines(c5SelectedOrders, isDropship = false) {
    isDropship = c5SelectedOrders[0] ? c5SelectedOrders[0].isDropship : isDropship
    const OrderlineIDs = c5SelectedOrders.map(item => item.OrderlineID)
    POST('orders/saveC5Orderlines', { OrderlineIDs, isDropship }).then(responseJSON => {
      if (responseJSON.error) {
        toast.error('Could not mark Orderlines as exported to PO system', {
          autoClose: 3000,
          onClose: () => {
            OrderActions.clearToast()
          }
        })
      } else {
        toast.success('Marked orderlines as exported to PO System', {
          autoClose: 3000,
          onClose: () => {
            OrderActions.clearToast()
          }
        })
      }
    })
    let selectedOrdersForStatus = []
    let selectedOrderlinesForSplice = []
    const c5ByOrderID = _.groupBy(c5SelectedOrders, 'OrderID')
    for (let OrderID in c5ByOrderID) {
      const orderlinesByOrderID = c5ByOrderID[OrderID]
      const originalOrder = this.state.orders.find(o => o.OrderID === +OrderID)
      if (originalOrder.orderlines.length === orderlinesByOrderID.length) {
        let userOrderlineMatch = selectedOrderlinesForSplice.find(item => item.UserID === originalOrder.UserID)
        if (userOrderlineMatch) {
          selectedOrderlinesForSplice = [...selectedOrderlinesForSplice, ...orderlinesByOrderID]
          continue
        }
        let userOrderMatch = selectedOrdersForStatus.find(item => item.UserID === originalOrder.UserID)
        if (userOrderMatch) {
          selectedOrdersForStatus = selectedOrdersForStatus.filter(item => item.OrderID !== userOrderMatch.OrderID)
          selectedOrderlinesForSplice = [...selectedOrderlinesForSplice, ...orderlinesByOrderID, ...userOrderMatch.orderlines]
        } else {
          selectedOrdersForStatus.push(originalOrder)
        }
      }
      if (originalOrder.orderlines.length > orderlinesByOrderID.length) {
        selectedOrderlinesForSplice = [...selectedOrderlinesForSplice, ...orderlinesByOrderID]
      }
    }
    if (selectedOrdersForStatus.length) {
      POST('orders/change-status', { status: isDropship ? 'SHIPPED' : 'ORDERED', ordersArray: selectedOrdersForStatus }).then(response => {
        if (response && !response.error) {
          this.getOrders()
          toast.success(`Order status changed successfully to ${isDropship ? 'SHIPPED' : 'ORDERED'}.`, {
            autoClose: 3000,
            onClose: () => {
              OrderActions.clearToast()
            }
          })
        }
      })
    }
    if (selectedOrderlinesForSplice.length) {
      POST('orders/splice', {
        orderlines: selectedOrderlinesForSplice.map(item => item.OrderlineID),
        orderFlowStatus: isDropship ? 'SHIPPED' : 'ORDERED'
      }).then(responseJSON => {
        if (responseJSON && !responseJSON.error) {
          this.getOrders()
          toast.success(`Orderlines status changed successfully to ${isDropship ? 'SHIPPED' : 'ORDERED'}.`, {
            autoClose: 3000,
            onClose: () => {
              OrderActions.clearToast()
            }
          })
        }
      })
    }
  }
  generateRegularShipment() {
    let CSVData = []
    let c5SelectedOrders = this.state.c5SelectedOrders
      .filter(item => !item.c5Exported)
      .map(item => {
        item.address = 'Ellekær 6, 2730 Herlev'
        return item
      })
    if (!c5SelectedOrders.length) {
      toast.error('No orderlines to export', {
        autoClose: 3000,
        onClose: () => {
          OrderActions.clearToast()
        }
      })
      return
    }
    let orderLines = _.groupBy(c5SelectedOrders, item => {
      return [item['ProductID'], item['address']]
    })
    Object.keys(orderLines).map((item, index) => {
      let rec = orderLines[item][0]
      index === 0 && CSVData.push(['ProductID', 'Delivery Address', 'Count', 'Note'])
      CSVData.push([rec.ProductID, rec.address, orderLines[item].length, ''])
    })
    let date = new Date()
      .toISOString()
      .split('T')
      .map(item => item.replace(/\D/g, ''))
    let fileName = `${date.join('_')}_${c5SelectedOrders[0].vendor}_REGULAR.CSV`

    let papasettings = {
      quotes: true,
      delimiter: ';',
      header: true
    }
    let csvDataString = ''
    CSVData.map(item => {
      if (item) {
        let data = item.join(';')
        csvDataString = csvDataString + data + ';\n'
      }
    })
    download(Papa.unparse(CSVData, papasettings), fileName)
    this.saveC5Orderlines(c5SelectedOrders)
    POST('orders/save-c5data-s3', { file: { csvDataString }, filename: fileName }).then(responseJSON => {
      if (responseJSON.error) {
        toast.error('Could not save file to S3', {
          autoClose: 3000,
          onClose: () => {
            OrderActions.clearToast()
          }
        })
      } else {
        toast.success('Uploaded file to S3', {
          autoClose: 3000,
          onClose: () => {
            OrderActions.clearToast()
          }
        })
      }
    })
    this.setState({ isAllOrderLinesChecked: false, selectedOrderLines: [], c5SelectedOrders: [] })
    this.logoutModal()
  }

  generatePurchaseOrder(orders) {
    let CSVData = []
    let c5SelectedOrders = this.state.c5SelectedOrders.filter(item => item.onPurchaseOrder === 'NO')
    if (!c5SelectedOrders.length) {
      toast.error('Some orderlines already exist on a Purchase Order', {
        autoClose: 3000,
        onClose: () => {
          OrderActions.clearToast()
        }
      })
      return
    }
    let orderLines = _.groupBy(c5SelectedOrders, item => {
      return [item['ProductID'], item['address']]
    })
    Object.keys(orderLines).map((item, index) => {
      let rec = orderLines[item][0]
      index === 0 && CSVData.push(['ProductID', 'Delivery Address', 'Count', 'Note'])
      CSVData.push([rec.ProductID, rec.address, orderLines[item].length, ''])
    })
    let date = new Date()
      .toISOString()
      .split('T')
      .map(item => item.replace(/\D/g, ''))
    let fileName = `${date.join('_')}_${c5SelectedOrders[0].vendor}_REGULAR.CSV`

    let csvDataString = ''
    CSVData.map(item => {
      if (item) {
        let data = item.join(';')
        csvDataString = csvDataString + data + ';\n'
      }
    })
    this.saveC5Orderlines(c5SelectedOrders)
    POST('orders/save-c5data-s3', { file: { csvDataString }, filename: fileName }).then(responseJSON => {
      if (responseJSON.error) {
        toast.error('Could not save file to S3', {
          autoClose: 3000,
          onClose: () => {
            OrderActions.clearToast()
          }
        })
      } else {
        toast.success('Uploaded file to S3', {
          autoClose: 3000,
          onClose: () => {
            OrderActions.clearToast()
          }
        })
      }
    })
    PurchaseOrderStoreActions.generatePurchaseOrder(orders)
    this.setState({ isAllOrderLinesChecked: false, selectedOrderLines: [], c5SelectedOrders: [] })
    this.logoutModal()
  }

  generateDropShipment() {
    let CSVData = []
    let c5SelectedOrders = this.state.c5SelectedOrders.filter(item => !item.c5Exported)
    if (!c5SelectedOrders.length) {
      toast.error('No orderlines to export', {
        autoClose: 3000,
        onClose: () => {
          OrderActions.clearToast()
        }
      })
      return
    }
    let orderLines = _.groupBy(c5SelectedOrders, 'UserID')
    Object.keys(orderLines).map((item, index) => {
      let orders = orderLines[item]
      let data = _.groupBy(orders, 'ProductID')
      index === 0 && CSVData.push(['ProductID', 'Delivery Address', 'Count', 'Note'])
      Object.keys(data).map((order, ind) => {
        if (
          order !== 'OrderlineID' &&
          order !== 'c5Exported' &&
          order !== 'UserID' &&
          order !== 'email' &&
          order !== 'phone' &&
          order !== 'productTitle'
        ) {
          let lines = data[order]
          CSVData.push([
            order,
            'See Note',
            `${lines.length}`,
            ind === Object.keys(data).length - 1
              ? `${lines[0].productTitle}, ${lines[0].address}, Email: ${lines[0].email}, Phone: ${lines[0].phone}`
              : ''
          ])
        }
      })
    })
    let date = new Date()
      .toISOString()
      .split('T')
      .map(item => item.replace(/\D/g, ''))
    let fileName = `${date.join('_')}_${this.state.c5SelectedOrders[0].vendor}_DROPSHIP.CSV`
    let papasettings = {
      quotes: true,
      delimiter: ';',
      header: true
    }
    download(Papa.unparse(CSVData, papasettings), fileName)
    let csvDataString = ''
    CSVData.map(item => {
      if (item) {
        let data = item.join(';')
        csvDataString = csvDataString + data + ';\n'
      }
    })
    this.saveC5Orderlines(c5SelectedOrders, true)
    POST('orders/save-c5data-s3', { file: { csvDataString }, filename: fileName }).then(responseJSON => {
      if (responseJSON.error) {
        toast.error('Could not save file to S3', {
          autoClose: 3000,
          onClose: () => {
            OrderActions.clearToast()
          }
        })
      } else {
        toast.success('Uploaded file to S3', {
          autoClose: 3000,
          onClose: () => {
            OrderActions.clearToast()
          }
        })
      }
    })
    this.setState({ isAllOrderLinesChecked: false, selectedOrderLines: [], c5SelectedOrders: [] })
    this.logoutModal()
  }
  setOrderCarrier(CarrierID) {
    this.setState({ trackingDetails: { ...this.state.trackingDetails, CarrierID: Number(CarrierID) } })
  }
  setTrackingNumber(trackingNumber) {
    this.setState({ trackingDetails: { ...this.state.trackingDetails, trackingNumber: trackingNumber } })
  }
  getCarriers(OrderID) {
    GET('carriers/pool', { OrderID: OrderID }).then(responseJSON => {
      if (responseJSON && !responseJSON.error) {
        this.setState({ carriers: responseJSON })
      }
    })
  }
  getTrackingDetails(OrderID) {
    GET('orders/get-tracking', { OrderID: OrderID }).then(responseJSON => {
      if (responseJSON && !responseJSON.error) {
        this.setState({ trackingDetails: responseJSON })
      } else {
        this.setState({
          trackingDetails: {
            TrackingOrderID: 0,
            CarrierID: 0,
            trackingNumber: ''
          }
        })
      }
    })
  }
  saveTrackingDetails() {
    if (!this.state.trackingDetails.CarrierID) {
      return this.removeTrackingDetails()
    }

    const orderTracking = { ...this.state.trackingDetails, OrderID: this.state.orderDetails.OrderID }
    POST('orders/save-tracking', orderTracking).then(responseJSON => {
      if (responseJSON && !responseJSON.error) {
        this.setState({ trackingDetails: responseJSON })
        toast.success('Saved tracking details', {
          autoClose: 3000,
          onClose: () => {
            OrderActions.clearToast()
          }
        })
      } else {
        toast.error('Could not save tracking details', {
          autoClose: 3000,
          onClose: () => {
            OrderActions.clearToast()
          }
        })
      }
    })
  }
  removeTrackingDetails() {
    POST('orders/remove-tracking', { OrderTrackingID: this.state.trackingDetails.OrderTrackingID }).then(responseJSON => {
      if (responseJSON && !responseJSON.error) {
        toast.success('Removed tracking details', {
          autoClose: 3000,
          onClose: () => {
            OrderActions.clearToast()
          }
        })
      } else {
        toast.error('Could not remove tracking details', {
          autoClose: 3000,
          onClose: () => {
            OrderActions.clearToast()
          }
        })
      }
    })
  }
  getTrackAndTraceEvents() {
    GET('orders/fetchTrackAndTraceEvents', {
      CarrierID: this.state.trackingDetails.CarrierID,
      trackingNumber: this.state.trackingDetails.trackingNumber
    }).then(responseJSON => {
      if (responseJSON && !responseJSON.error) {
        this.setState({ trackAndTraceEvents: responseJSON })
      } else {
        this.setState({
          trackAndTraceEvents: []
        })

        toast.error('Could not fetch tracking', {
          autoClose: 3000,
          onClose: () => {
            OrderActions.clearToast()
          }
        })
      }
    })
  }
  goToTrackingUrl() {
    const carrier = this.state.carriers.find(c => c.CarrierID === this.state.trackingDetails.CarrierID)
    const trackingUrl = `${carrier.trackingPrefix}${this.state.trackingDetails.trackingNumber}`
    window.open(trackingUrl, '_blank')
  }

  setOverrideShipmentDate(overrideShipmentDate) {
    this.setState({ orderDetails: { ...this.state.orderDetails, overrideShipmentDate: overrideShipmentDate } })
  }
  setExpectedShipmentDate(expectedShipmentDate) {
    this.setState({ orderDetails: { ...this.state.orderDetails, expectedShipmentDate: expectedShipmentDate } })
  }
  saveShipmentDates() {
    const shipmentDates = {
      OrderID: this.state.orderDetails.OrderID,
      overrideShipmentDate: this.state.orderDetails.overrideShipmentDate,
      expectedShipmentDate: this.state.orderDetails.expectedShipmentDate
    }
    POST('orders/saveShipmentDates', shipmentDates).then(responseJSON => {
      if (responseJSON && !responseJSON.error) {
        toast.success('Saved shipment dates', {
          autoClose: 3000,
          onClose: () => {
            OrderActions.clearToast()
          }
        })
      } else {
        toast.error('Could not save shipment dates', {
          autoClose: 3000,
          onClose: () => {
            OrderActions.clearToast()
          }
        })
      }
    })
  }

  releaseStock(orderlineID) {
    POST('orders/releaseStock', { OrderlineID: orderlineID }).then(responseJSON => {
      if (responseJSON && !responseJSON.error) {
        const orderline = this.state.orderDetails.orderlines.find(ol => ol.OrderlineID === orderlineID)
        const orderlines = this.state.orderDetails.orderlines.map(ol => {
          // Increase the stock of the variation for all orderlines
          const variations = ol.product.variations.map(v => {
            if (v.VariationID === orderline.VariationID) {
              return { ...v, variationStock: v.variationStock + 1 }
            } else {
              return v
            }
          })

          if (ol.OrderlineID === orderlineID) {
            return { ...ol, product: { ...ol.product, variations: variations }, reservedStock: false }
          } else {
            return { ...ol, product: { ...ol.product, variations: variations } }
          }
        })
        this.setState({ orderDetails: { ...this.state.orderDetails, orderlines: orderlines } })
      } else {
        toast.error('Could not release stock for this orderline', {
          autoClose: 3000,
          onClose: () => {
            OrderActions.clearToast()
          }
        })
      }
    })
  }

  reserveStock(orderlineID) {
    POST('orders/reserveStock', { OrderlineID: orderlineID }).then(responseJSON => {
      if (responseJSON && !responseJSON.error) {
        const orderline = this.state.orderDetails.orderlines.find(ol => ol.OrderlineID === orderlineID)
        const orderlines = this.state.orderDetails.orderlines.map(ol => {
          // Decrease the stock of the variation for all orderlines
          const variations = ol.product.variations.map(v => {
            if (v.VariationID === orderline.VariationID) {
              return { ...v, variationStock: v.variationStock - 1 }
            } else {
              return v
            }
          })

          if (ol.OrderlineID === orderlineID) {
            return { ...ol, product: { ...ol.product, variations: variations }, reservedStock: true }
          } else {
            return { ...ol, product: { ...ol.product, variations: variations } }
          }
        })
        this.setState({ orderDetails: { ...this.state.orderDetails, orderlines: orderlines } })
      } else {
        toast.error('Could not reserve stock for this orderline', {
          autoClose: 3000,
          onClose: () => {
            OrderActions.clearToast()
          }
        })
      }
    })
  }
}
